<template>
  <div class="edit-questionaire" :class="[shelfStyle ? 'shelf' : 'book', { height_1: (iconType === -1 || iconType === 20) && questionnaire }]">
    <div class="edit-questionaire-item switch">
      <div class="edit-questionaire-item-title">
        <span class="title">在线问卷</span>
        <i :class="shelfStyle ? 'vip-normal' : 'vip-mini'">VIP</i>
      </div>
      <div class="edit-questionaire-item-content">
        <el-select class="edit-questionaire-item-select" v-model="questionnaire" size="mini" @change="selectChange">
          <el-option v-for="item in selectOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>
    <div v-if="questionnaire" class="edit-questionaire-item">
      <div class="edit-questionaire-item-title">
        <span class="title">问卷来源</span>
      </div>
      <div class="edit-questionaire-item-content">
        <el-radio v-model="questionType" :label="0" @change="questionaireRadioHandler">云阅读问卷</el-radio>
        <el-radio v-model="questionType" :label="1" @change="questionaireRadioHandler">外链问卷</el-radio>
      </div>
    </div>
    <div v-if="questionnaire" class="edit-questionaire-item">
      <div class="edit-questionaire-item-title">
        <span class="title">{{ questionaireContentTitle }}</span>
      </div>
      <div class="edit-questionaire-item-content">
        <div v-if="questionType === 0" class="setting-button" @click="settingButtonHandler">设置</div>
        <el-input v-else v-model="questionContentLink" size="mini" :disabled="!isAllowed"></el-input>
      </div>
    </div>

    <div v-if="paperStyle && questionnaire" class="edit-questionaire-item">
      <div class="edit-questionaire-item-title">
        <span class="title">pc端问卷名称</span>
      </div>
      <div class="edit-questionaire-item-content">
        <el-input v-model="pcQuestionName" size="mini"></el-input>
      </div>
    </div>

    <!-- 仅书刊编辑有的功能 -->
    <div v-if="type === 'book' && questionnaire" class="edit-questionaire-item">
      <div class="edit-questionaire-item-title">
        <span class="title">问卷图标</span>
      </div>
      <div class="edit-questionaire-item-content">
        <el-select class="edit-questionaire-item-select" v-model="iconType" size="mini" @change="iconSelectChange">
          <el-option v-for="item in iconSelectOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <div class="uploadlogo" v-show="iconType === -1">
          <div class="upload">
            <el-select class="edit-questionaire-item-select pic-list" size="mini" v-model="questionIcon">
              <el-option class="pic-list-item question-icon" v-for="(item, index) in uploadIconList" :key="'uploadQuestion' + index" :label="item.name" :value="item.path">
                {{ item.name }}
                <img class="select-del" src="@imgs/delete-gray.png" @click="delIcon(item, $event)" />
              </el-option>
            </el-select>
            <label class="uploadlogoButton" for="uploadQuestionButton">上传</label>
            <input
              type="file"
              id="uploadQuestionButton"
              ref="uploadQuestion"
              value="imgFile"
              accept="image/png, image/jpg, image/jpeg, image/gif"
              @change="uploadQuestionImg($event)"
              style="display: none"
            />
          </div>
          <div v-if="questionIcon && questionIcon.length > 2" class="thumbnail"><img :src="questionIcon" alt="" /></div>
          <div class="thumbnail upload-tip" v-else>
            <p>建议尺寸80*80</p>
            <p>显示效果最佳</p>
          </div>
        </div>
      </div>
    </div>
    <div class="edit-questionaire-item" v-if="type === 'book' && questionnaire && iconType >= 20">
      <div class="edit-questionaire-item-title">
        <span class="title">文字内容</span>
      </div>
      <div class="edit-questionaire-item-content">
        <el-input style="width: 135px" v-model="questionIcon" placeholder="请输入" @change="checkWord" maxlength="12" size="mini"></el-input>
        <div class="warning-text" v-if="showWarning">请输入1-6个汉字</div>
      </div>
    </div>
    <div class="edit-questionaire-item" v-if="type === 'book' && questionnaire && iconType >= 20">
      <div class="edit-questionaire-item-title">
        <span class="title">文字样式</span>
      </div>
      <div class="edit-questionaire-item-content">
        <el-select class="edit-questionaire-item-select" size="mini" v-model="textIconStyle">
          <el-option class="pic-list-item question-icon" v-for="(item, index) in textIconStyleOptions" :key="'shopText' + index" :label="item.label" :value="item.value">
            {{ item.label }}
          </el-option>
        </el-select>
      </div>
    </div>
    <TipDialog ref="memberDialog" :dialogOptions="memberDialogOptions"></TipDialog>
    <TipDialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" @clickCancel="deleteCancel" @clickConfirm="deleteConfrim" :appendToBody="true"></TipDialog>
    <EditQuestionaireDialog ref="editQuestionaireDialog" :type="type"></EditQuestionaireDialog>
  </div>
</template>

<script>
import TipDialog from '@components/common/TipDialog.vue'
import EditQuestionaireDialog from './questionaire/editQuestionaireDialog.vue'
import compareVipRight from '@components/common/compareVipRight.js'
import setBook from '@api/setBook'
import { getStrByteCount, uploadIconPic } from '@/utils'
export default {
  name: 'editQuestionaire',
  data() {
    return {
      lastIcon: 0,
      selectOptions: [
        {
          value: 1,
          label: '开启'
        },
        {
          value: 0,
          label: '关闭'
        }
      ],
      iconSelectOptions: [
        {
          value: 0,
          label: '问卷'
        },
        {
          value: 1,
          label: '留言反馈'
        },
        {
          value: 2,
          label: '订购'
        },
        {
          value: 3,
          label: '在线投稿'
        },
        {
          value: 4,
          label: '报名'
        },
        {
          value: -1,
          label: '自定义图片图标'
        },
        {
          value: 20,
          label: '自定义文字图标'
        }
      ],
      textIconStyleOptions: [
        {
          value: 20,
          label: '样式一'
        },
        {
          value: 21,
          label: '样式二'
        }
      ],
      showWarning: false,
      isUpload: false,
      uploadIconList: [],
      deletePic: null,
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '是否确认删除？'
      }
    }
  },
  props: {
    type: {
      type: String,
      default: 'book'
    }
  },
  mixins: [compareVipRight],
  computed: {
    isAllowed() {
      return this.compare({ type: 'boole', key: 'questionnaire' })
    },
    shelfStyle() {
      return this.type !== 'book'
    },
    questionnaire: {
      get: function() {
        return this.$store.state.config[this.type + 'Obj'].questionnaire
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: this.type + 'Obj', key: 'questionnaire', value: value })
      }
    },
    questionIcon: {
      get: function() {
        // 默认类型=0
        return this.$store.state.config[this.type + 'Obj'].questionIcon
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: this.type + 'Obj', key: 'questionIcon', value: value })
      }
    },
    iconType: {
      get: function() {
        // 默认类型=0
        return this.$store.state.config[this.type + 'Obj'].questionIconType > 20 ? 20 : this.$store.state.config[this.type + 'Obj'].questionIconType
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: this.type + 'Obj', key: 'questionIconType', value: value })
      }
    },
    textIconStyle: {
      get: function() {
        return this.$store.state.config[this.type + 'Obj'].questionIconType
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: this.type + 'Obj', key: 'questionIconType', value: value })
      }
    },
    questionType: {
      get: function() {
        return this.$store.state.config[this.type + 'Obj'].questionType
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: this.type + 'Obj', key: 'questionType', value: value })
      }
    },
    // 问卷外链
    questionContentLink: {
      get: function() {
        return this.$store.state.config[this.type + 'Obj'].questionContentLink
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: this.type + 'Obj', key: 'questionContentLink', value: value })
      }
    },
    pcQuestionName: {
      get: function() {
        return this.$store.state.config.bookObj.pcQuestionName || '问卷'
      },
      set: function(value) {
        this.$store.commit('config/PCQUESTION_NAME', value)
      }
    },
    questionairePublishedFlag() {
      return this.$store.state.config.questionairePublishedFlag
    },
    questionaireContentTitle() {
      return this.questionType === 0 ? '问卷内容' : '问卷链接'
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    },
    paperStyle() {
      return this.$store.state.config.paperStyle
    }
  },
  watch: {
    questionIcon(newV, oldV) {
      this.lastIcon = oldV
    }
  },
  methods: {
    async selectChange(value) {
      if (value) {
        this.$store.commit('config/PCQUESTION_NAME', this.pcQuestionName)
        if (!(await this.compareRight({ type: 'boole', key: 'questionnaire' }))) {
          this.$refs.memberDialog.visible = true
          this.questionnaire = 0
        }
      }
    },
    async iconSelectChange(value) {
      if (value === -1) {
        this.isUpload = true
        this.questionIcon = ''
      } else {
        this.isUpload = false
        if (value < 20) {
          this.questionIcon = value
        } else {
          this.questionIcon = ''
        }
      }
      if (!(await this.compareRight({ type: 'boole', key: 'questionnaire' }))) {
        this.$refs.memberDialog.visible = true
        this.questionIcon = this.lastIcon
      }
    },
    async getImage(module) {
      await setBook.getImageList({ module: module }).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          this.uploadIconList = res.data.data
        } else {
          console.log('获取图片列表失败')
        }
      })
    },
    delIcon(item, e) {
      this.deletePic = item
      this.$refs.deleteDialog.visible = true
    },
    checkWord(value) {
      let strByteCount = getStrByteCount(value)
      this.showWarning = strByteCount > 12 || strByteCount < 1
    },
    async uploadQuestionImg(e) {
      const result = await uploadIconPic(e, 'questionnaireIcon', 1, this)
      if (result && result.length > 0) {
        this.uploadIconList = result
        this.questionIcon = this.uploadIconList[0].path
      }
    },
    deleteCancel() {
      this.$refs.deleteDialog.visible = false
      this.deletePic = null
    },
    deleteConfrim() {
      let module = this.deletePic.module
      setBook.delImage({ ids: this.deletePic.id }).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          this.getImage(module)
          this.questionIcon = ''
        } else {
          console.log('删除背景列表失败')
        }
      })
      this.deletePic = null
      this.$refs.deleteDialog.visible = false
    },
    async questionaireRadioHandler(value) {
      if (!(await this.compareRight({ type: 'boole', key: 'questionnaire' }))) {
        this.$refs.memberDialog.visible = true
        this.questionType = value === 0 ? 1 : 0
      }
    },
    async settingButtonHandler() {
      if (!(await this.compareRight({ type: 'boole', key: 'questionnaire' }))) {
        this.$refs.memberDialog.visible = true
      } else {
        this.$refs.editQuestionaireDialog.visible = true
        this.$store.commit('config/UPDATE_IS_PUBLISH', false)
      }
    },
    check() {
      // 开启问卷必须设置内容
      const type = this.type + 'Obj'
      if (
        (this.questionnaire === 1 &&
          ((this.questionType === 1 && this.questionContentLink) ||
            (this.questionType === 0 && (typeof this.$store.state.config[type].questionContent.id !== 'undefined' || this.questionairePublishedFlag)))) ||
        this.questionnaire === 0
      ) {
        return true
      } else {
        return false
      }
    },
    getData() {
      const type = this.type + 'Obj'
      const questionContent =
        this.questionType === 0
          ? this.questionairePublishedFlag || typeof this.$store.state.config[type].questionContent.id !== 'undefined'
            ? JSON.stringify({ formName: this.$store.state.config[type].questionContent.formName, construction: this.$store.state.config[type].questionContentConstruction })
            : ''
          : this.questionContentLink
      const data = {
        questionnaire: this.questionnaire,
        questionType: this.questionType,
        questionContent: questionContent,
        questionIcon: this.textIconStyle
      }
      if (this.iconType === -1) {
        data.questionnaireIcon = this.questionIcon.substring(this.questionIcon.indexOf('attach/'))
      } else if (this.textIconStyle >= 20) {
        data.questionnaireIcon = this.questionIcon
      }
      this.$store.commit('config/UPDATE_QUESTIONAIRE_FLAG', false)
      return data
    }
  },
  mounted() {
    // 重置发布状态，用以标识用户是否修改过问卷
    this.$store.commit('config/UPDATE_QUESTIONAIRE_FLAG', false)
    this.getImage('questionnaireIcon')
  },
  components: {
    TipDialog,
    EditQuestionaireDialog
  }
}
</script>
<style lang="scss" scoped>
.edit-questionaire {
  display: flex;
  flex-direction: column;
  &.height_1 {
    height: 300px;
  }
  .edit-questionaire-item {
    display: inline-flex;
    align-items: center;
    margin-bottom: 18px;
    /*&:nth-child(4) {
      margin-bottom: 0 !important;
    }*/
    .edit-questionaire-item-title {
      width: 115px;
      margin-right: 10px;
      text-align: right;
    }
    .edit-questionaire-item-content {
      height: 24px;
      line-height: 24px;
      .setting-button {
        width: 60px;
        height: 20px;
        border-radius: 10px;
        background-color: #df5813;
        color: #fff;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
        margin-top: 2px;
        font-size: 14px;
      }
      .warning-text {
        color: #d33636;
      }
    }
  }
  .uploadlogo {
    align-self: flex-end;
    .uploadlogoButton {
      width: 55px;
      height: 24px;
      background: #df5813;
      color: #fff;
      border-radius: 15px;
      font-size: 14px;
      display: inline-flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      margin: 10px 0 0 8px;
      cursor: pointer;
    }
    .thumbnail {
      width: 120px;
      height: 35px;
      background: #fffaf4;
      color: #515151;
      margin-top: 5px;
      p {
        width: 100%;
        text-align: center;
        font-size: 14px;
        margin: 0;
        line-height: 17px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .logoUrlTxt {
      margin: 5px 0;
      font-size: 14px;
    }
  }

  /deep/ .el-radio {
    margin-right: 5px;
    .el-radio__label {
      padding-left: 3px;
    }
  }
}
.edit-questionaire.shelf {
  .edit-questionaire-item {
    &.switch {
      flex-direction: column;
      align-items: flex-start;
      .edit-questionaire-item-content {
        margin-top: 5px;
      }
    }
    .edit-questionaire-item-title {
      width: auto;
      .title {
        font-size: 16px;
        color: #000;
        font-weight: 400;
      }
    }
  }
}
.edit-questionaire.book {
  /deep/ .el-select {
    width: 136px;
  }
  /deep/ .el-input {
    width: 136px;
    .el-input__inner {
      border-color: #cecece;
      height: 24px;
      font-size: 13px;
      padding: 0 5px;
      line-height: 24px;
    }
    .el-input__icon {
      line-height: 24px;
      &::before {
        color: #515151;
      }
      &::after {
        color: #515151;
      }
    }
  }
}
</style>
<style lang="scss">
.el-select-dropdown {
  .question-icon {
    width: 120px !important;
  }
}
</style>
